export enum AppRoutes {
  LOGIN = "/login",
  HOME = "/",
  ADMIN = "/admin",
  PDF = "/pdf",
}
